import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { TimePicker } from "@design-system/TimePicker/TimePicker";
import { formatDuration } from "@design-system/TimePicker/TimePicker.lib";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";
import taskStyles from "@components/drawers/TaskDrawerFields.module.scss";

interface Props {
    value: number | null;
    onChange: (value: number | null) => void;
}

export const EstimateField = ({ value, onChange }: Props) => {
    const formattedValue = formatDuration(value ?? undefined);

    return (
        <DescriptionListItem label="Estimate">
            <div className={taskStyles.detailSelectWrapper}>
                <TimePicker
                    hideIcon
                    value={value ?? undefined}
                    onChange={(nextValue) => onChange(nextValue ?? null)}
                    trigger={
                        <Button
                            variant="primary"
                            size="md"
                            type="button"
                            block={false}
                            className={classNames(
                                taskStyles.detailSelectTrigger,
                                taskStyles.justifyLeft,
                                {
                                    [taskStyles.emptyValue]: value === null,
                                },
                            )}
                        >
                            {formattedValue || "None"}
                        </Button>
                    }
                />
            </div>
        </DescriptionListItem>
    );
};
